import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'
import Vue from "vue";
import VueExcelEditor from "vue-excel-editor";

Vue.use(VueExcelEditor);

export default {
  mixins: [mixx],
  name: 'ventasLiquiDet',
  data() {
    return {
      msg: '-',
      data: [],
      loading: false,
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -7),
        hasta: this.currentdate(),
      }

    }
  },
  computed: {
    reporte: function () {
      return '/reportes/lote/equipo/liquidacion?dsis=' + window.sssdi + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta
    }
  },
  mounted: function () {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $('.box').boxWidget();
    this.tbv = $("#ventas").DataTable({
      paging: true,
      lengthChange: true,
      searching: true,
      ordering: true,
      info: true,
      order: [],
      autoWidth: true,
      orderCellsTop: true,
      fixedHeader: true,
      rowCallback: function (row, data, index) { }
    });
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/reportes/lote/equipo/liquidacion', this.f_c)
        .then(response => {
          response.data.data.forEach(element => {
            element[10] = this.num_to_many(element[10]);
            element[11] = this.num_to_many(element[11]);
            element[12] = this.num_to_many(element[12]);
            element[13] = this.num_to_many(element[13]);
            element[14] = this.num_to_many(element[14]);
            element[15] = this.num_to_many(element[15]);
            element[16] = this.num_to_many(element[16]);
            this.tbv.row.add(element);
          });
         
          this.tbv.draw();
          this.loading = false;
        });
    },

  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/ventasLiquiDet2/index.js